module.exports = __webpack_public_path__ + "img/leader.7ea14154.svg";